<template>
  <div class="features-bar">
    <!-- Item 1 -->
    <div class="feature-item">
      <div class="feature-icon">
        <img src="../assets/FeaturesBar/核心伙伴.png" alt="腾讯 ToB 生态核心合作伙伴" />
      </div>
      <div class="feature-text">
        <div class="line">腾讯 ToB 生态</div>
        <div class="line">核心合作伙伴</div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Item 2 -->
    <div class="feature-item">
      <div class="feature-icon">
        <img src="../assets/FeaturesBar/企业数字化.png" alt="企业数字化转型服务商" />
      </div>
      <div class="feature-text">
        <div class="line">企业数字化</div>
        <div class="line">转型服务商</div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Item 3 -->
    <div class="feature-item">
      <div class="feature-icon">
        <img src="../assets/FeaturesBar/安全可信.png" alt="安全可信交付" />
      </div>
      <div class="feature-text">
        <div class="line">安全可信</div>
        <div class="line">交付</div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Item 4 -->
    <div class="feature-item">
      <div class="feature-icon">
        <img src="../assets/FeaturesBar/全国服务.png" alt="全国服务网络" />
      </div>
      <div class="feature-text">
        <div class="line">全国</div>
        <div class="line">服务网络</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturesBar',
}
</script>

<style scoped>
.features-bar {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 82, 217, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 48px;
  max-width: 1360px;
  margin: -60px auto 60px;
  position: relative;
  z-index: 10;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  justify-content: center;
}

.feature-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.feature-text {
  display: flex;
  flex-direction: column;
}

.feature-text .line {
  font-size: 15px;
  color: #333;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
}

.divider {
  width: 1px;
  height: 40px;
  background-color: #e5e5e5;
  flex-shrink: 0;
}

@media (max-width: 1200px) {
  .features-bar {
    padding: 24px 32px;
    margin: -40px 20px 40px;
  }
  .feature-icon {
    width: 48px;
    height: 48px;
  }
  .feature-text .line {
    font-size: 13px;
  }
}

@media (max-width: 900px) {
  .features-bar {
    flex-wrap: wrap;
    gap: 20px;
    padding: 24px;
    margin: -20px 16px 30px;
  }
  .feature-item {
    flex: 0 0 calc(50% - 20px);
  }
  .divider {
    display: none;
  }
}

@media (max-width: 600px) {
  .features-bar {
    margin: 16px 12px 24px;
    padding: 20px 16px;
    border-radius: 8px;
  }
  .feature-item {
    flex: 0 0 100%;
    gap: 12px;
  }
  .feature-icon {
    width: 40px;
    height: 40px;
  }
  .feature-text .line {
    font-size: 14px;
  }
}
</style>
